import React, { ReactNode } from "react"
import "./layout.css"

const Layout = ({ children }: { children: ReactNode[] }) => {
  return <main className="layout-main">{children}</main>
}

export default Layout
